import { render, staticRenderFns } from "./blearnword.vue?vue&type=template&id=52d90f54&scoped=true&"
import script from "./blearnword.vue?vue&type=script&lang=js&"
export * from "./blearnword.vue?vue&type=script&lang=js&"
import style0 from "./blearnword.vue?vue&type=style&index=0&id=52d90f54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d90f54",
  null
  
)

export default component.exports